module.exports = __webpack_public_path__ + "img/card-specialists.954d178a.svg";